
const contents = "query InformationBarrierSettingsClients($userId: ID!) {\n  user: node(id: $userId) {\n    ... on User {\n      id\n      officeUserId\n      hasInformationBarrierRestrictions\n    }\n  }\n}\n";
const sha256Hash = "dd93c182cc8d2d83bb0e608933604bb717bfdbc89ee8c46145ce2e7ea2c9a58f";
export default { contents: contents, sha256Hash: sha256Hash };
